
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-service/account-profile",
      function () {
        return require("private-next-pages/customer-service/account-profile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-service/account-profile"])
      });
    }
  